<template>
    <div class="pay_unit_month">
        <div class="data-wrap">
            <el-form
                class="leader-style-form"
                inline
                :model="searchForm"
                ref="searchForm"
            >
                <el-form-item
                    label="月份"
                    prop="show_month"
                    :rules="[
                        {
                            required: false,
                            message: '请选择月份',
                            trigger: 'blur'
                        }
                    ]"
                >
                    <el-date-picker
                        v-model="searchForm.show_month"
                        type="month"
                        clearable
                        placeholder="选择月"
                        value-format="yyyy-MM"
                        :picker-options="pickerOptions"
                        @change="handleTimeChange"
                    ></el-date-picker>
                </el-form-item>
                <el-form-item label="用户名称">
                    <el-input
                        v-model="searchForm.pay_unit_name"
                        maxlength="200"
                        clearable
                    ></el-input>
                </el-form-item>
                <el-form-item style="float: right">
                    <el-button @click="searchClick">查询</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="table-wrap" style="height: 32.5rem;">
            <div style="text-align: center;margin-bottom: 0.5rem;">
                <el-radio-group
                    v-model="selectType"
                    class="leader-style-radio power-radio"
                    @change="changeRadio"
                >
                    <el-radio-button
                        v-for="item in radios"
                        :label="item.point_class_id"
                        :key="item.point_class_id"
                        >{{ item.class_name }}</el-radio-button
                    >
                </el-radio-group>
            </div>
            <el-scrollbar style="height: 83%;">
                <el-table class="leader-style-table" border :data="tableData">
                    <el-table-column width="50" align="center" label="序号">
                        <template slot-scope="scope">
                            <span>{{
                                (pageNum - 1) * pageSize + scope.$index + 1
                            }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="用户名称"
                        property="pay_unit_name"
                        align="center"
                    ></el-table-column>
                    <el-table-column
                        label="月份"
                        property="show_month"
                        align="center"
                    ></el-table-column>
                    <el-table-column
                        :label="tableUnit"
                        property="total_power"
                        align="center"
                    ></el-table-column>
                    <el-table-column
                        label="统计费用-元"
                        property="power_money"
                        align="center"
                    ></el-table-column>
                    <el-table-column
                        label="增减费用-元"
                        property="off_money"
                        align="center"
                    ></el-table-column>
                    <el-table-column
                        label="总费用-元"
                        property="total_money"
                        align="center"
                    ></el-table-column>
                    <el-table-column
                        label="备注"
                        property="remark"
                        align="center"
                    ></el-table-column>
                    <el-table-column label="修改" align="center" width="200">
                        <template slot-scope="scope">
                            <el-button
                                @click="addEdit('修改', scope.row)"
                                type="text"
                                >修改
                            </el-button>
                            <el-button
                                @click="addEdit('查看', scope.row)"
                                type="text"
                            >
                                查看
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-scrollbar>

            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[10, 20, 30, 40, 50, 100]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalNum"
                class="leader-style-pagination"
            ></el-pagination>
        </div>
        <!-- 修改， 查看 -->
        <el-dialog
            :title="dialogTitle"
            width="70%"
            :visible.sync="dialogStatus"
            class="leader-dialog"
            :close-on-click-modal="false"
            @close="closeDialog"
        >
            <div style="height: 20rem;">
                <div style="text-align: right; margin-bottom: 0.5rem">
                    <el-button class="leader-common-button" @click="getExecl"
                        >导出</el-button
                    >
                </div>
                <el-scrollbar style="height: 100%">
                    <el-table
                        class="leader-style-table"
                        border
                        :data="innerTableData"
                    >
                        <el-table-column width="50" align="center" label="序号">
                            <template slot-scope="scope">
                                <span>{{
                                    (innerPageNum - 1) * innerPageSize +
                                        scope.$index +
                                        1
                                }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="表号"
                            property="factory_no"
                            align="center"
                        ></el-table-column>
                        <el-table-column
                            label="开始时间"
                            property="beg_time"
                            align="center"
                        ></el-table-column>
                        <el-table-column
                            label="截止时间"
                            property="end_time"
                            align="center"
                        ></el-table-column>
                        <el-table-column
                            label="用量"
                            property="total_power"
                            align="center"
                        ></el-table-column>
                        <el-table-column
                            label="单价"
                            property="pay_price"
                            align="center"
                        ></el-table-column>
                        <el-table-column
                            label="费用"
                            property="total_money"
                            align="center"
                        ></el-table-column> </el-table
                ></el-scrollbar>
            </div>
            <el-pagination
                @size-change="handleInnerSizeChange"
                @current-change="handleInnerCurrentChange"
                :current-page="innerCurrentPage"
                :page-sizes="[10, 20, 30, 40, 50, 100]"
                :page-size="innerPageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="innerTotalNum"
                class="leader-style-pagination"
            ></el-pagination>
            <el-form
                :model="innerForm"
                ref="innerForm"
                label-width="80px"
                class="leader-style-form"
                style="margin-top: 0.5rem;"
            >
                <el-row>
                    <el-col :span="6">
                        <el-form-item label="增减费用">
                            <el-input
                                v-model="innerForm.off_money"
                                maxlength="20"
                                type="number"
                                :disabled="dialogTitle == '查看'"
                                placeholder="请输入增减费用"
                                clearable
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="18">
                        <el-form-item label="备注">
                            <el-input
                                v-model="innerForm.remark"
                                type="textarea"
                                rows="3"
                                :disabled="dialogTitle == '查看'"
                                maxlength="20"
                                placeholder="请输入备注"
                                clearable
                            ></el-input> </el-form-item
                    ></el-col>
                </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="closeDialog" class="leader-common-button">{{
                    dialogTitle == "查看" ? "关闭" : "取消"
                }}</el-button>
                <el-button
                    @click="saveUnitMonth()"
                    type="primary"
                    v-show="dialogTitle != '查看'"
                    class="leader-common-button"
                    >保存</el-button
                >
            </div>
        </el-dialog>
    </div>
</template>
<script>
import * as api from "@/http/api.js";
import moment from "moment";
export default {
    data() {
        return {
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now();
                }
            },
            searchForm: {
                pay_unit_name: "",
                show_month: ""
            },
            selectType: "",
            radios: [],
            pageNum: 1, //页码
            pageSize: 10, //每页条数
            currentPage: 1, //当前页码
            totalNum: 0, //总条数
            tableData: [],
            tableUnit: "",
            dialogTitle: "修改",
            dialogStatus: false,
            innerTableData: [],
            innerPageNum: 1, //页码
            innerPageSize: 10, //每页条数
            innerCurrentPage: 1, //当前页码
            innerTotalNum: 0, //总条数
            innerForm: {
                pay_job_month_main_id: "",
                off_money: "",
                remark: ""
            }
        };
    },
    async mounted() {
        await this.getSysDate();
        await this.getPayUnitPointClassList();
        await this.getPayUnitMonthList();
    },
    methods: {
        // 获取时间
        async getSysDate() {
            await api.getSysDate().then(res => {
                if (res && res.error_code == 0) {
                    // this.searchForm.show_month = res.bus_json.sysdate3;
                    // this.searchForm.show_month = moment(res.bus_json.sysdate3)
                    //     .subtract(1, "months")
                    //     .format("YYYY-MM");
                }
            });
        },
        // 获取类型
        async getPayUnitPointClassList() {
            await api.getPayUnitPointClassList().then(res => {
                if (res && res.error_code == 0) {
                    this.radios = res.bus_json;
                    if (this.radios.length > 0) {
                        this.selectType = this.radios[0].point_class_id;
                    }
                }
            });
        },
        // 获取列表
        async getPayUnitMonthList() {
            await api
                .getPayUnitMonthList({
                    pageNum: this.pageNum,
                    pageSize: this.pageSize,
                    point_class_id: this.selectType,
                    ...this.searchForm
                })
                .then(res => {
                    if (res && res.error_code == 0) {
                        this.totalNum = res.bus_json.pageData.totalNum;
                        this.tableData = res.bus_json.pageData.items;
                        this.tableUnit = `总量-${res.bus_json.unit}`;
                    }
                });
        },
        searchClick() {
            this.$refs["searchForm"].validate(valid => {
                if (valid) this.getPayUnitMonthList();
            });
        },
        // 类型切换
        changeRadio(val) {
            this.selectType = val;
            this.getPayUnitMonthList();
        },
        addEdit(title, row) {
            this.dialogTitle = title;
            if (row.pay_job_month_main_id) {
                this.dialogStatus = true;
                this.innerForm = { ...row };
                api.getPayUnitMonthInfo({
                    pageNum: this.innerPageNum,
                    pageSize: this.innerPageSize,
                    pay_job_month_main_id: row.pay_job_month_main_id
                }).then(res => {
                    if (res && res.error_code == 0) {
                        this.innerTableData = res.bus_json.items;
                        this.innerTotalNum = res.bus_json.totalNum;
                    }
                });
            } else {
                this.$message({
                    message: "无数据",
                    type: "warning"
                });
            }
        },
        // 保存
        saveUnitMonth() {
            this.$refs["innerForm"].validate(valid => {
                if (valid) {
                    api.saveOffMoney({
                        ...this.innerForm
                    }).then(res => {
                        if (res && res.error_code == 0) {
                            this.dialogStatus = false;
                            this.$message({
                                message: res.error_msg,
                                type: "success"
                            });
                            this.getPayUnitMonthList();
                        }
                    });
                }
            });
        },
        getExecl() {
            api.getPayUnitMonthExecl({
                pay_job_month_main_id: this.innerForm.pay_job_month_main_id
            }).then(res => {
                if (res) {
                    const content = res;
                    const blob = new Blob([content]);
                    const fileName = "外部用电" + ".xlsx";
                    if (window.navigator.msSaveOrOpenBlob) {
                        navigator.msSaveBlob(blob, fileName);
                    } else {
                        let link = document.createElement("a");
                        link.href = window.URL.createObjectURL(blob);
                        link.download = fileName;
                        document.body.appendChild(link);
                        let evt = document.createEvent("MouseEvents");
                        evt.initEvent("click", false, false);
                        link.dispatchEvent(evt);
                        document.body.removeChild(link);
                    }
                    this.$message({
                        message: "下载成功！",
                        type: "success"
                    });
                }
            });
        },
        closeDialog() {
            this.dialogStatus = false;
        }
    }
};
</script>
<style lang="scss">
.pay_unit_month {
    width: 100%;
    height: 100%;
    padding: 0 20px 20px 20px;
    box-sizing: border-box;
    .data-wrap {
        // background: url("../../../../assets/image/custom/table-bg.png")
        //     no-repeat;
        background-size: 100% 100%;
        padding: 20px;
        box-sizing: border-box;
        width: 100%;
        // height: 100%;
    }
    .power-radio {
        .el-radio-button {
            margin-right: 0.3rem !important;
        }
        .el-radio-button__inner {
            font-size: 0.7rem !important;
            padding: 0.5rem 0.3rem !important;
            border-radius: 5px;
            min-width: 3.5rem;
        }
        .el-radio-button__inner,
        .el-radio-group {
            margin: 0.2rem 0;
        }
    }
    .table-data {
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        padding: 20px 0;
    }
}
</style>
